var $ = require("jquery");

$('[data-popup-youtube]').each(function () {

    var Popup = require("utils/popup");
    var PopupYoutube = require("atomic/organism/o-popup-youtube/o-popup-youtube.chunk.js");

    var closeLabel = "Fermer";
    if ($('html[lang*=en]').length > 0) {
        closeLabel = "Close";
    }

    var $elm = $(this),
        videoId = "";

    if ($elm.attr("data-popup-youtube").trim() != "")
        videoId = $elm.attr("data-popup-youtube").trim();

    var videoPopup = new Popup({
        view: new PopupYoutube({
            closeLabel: closeLabel,
            videoId: videoId
        }),
        onDomReady: onPopupReady
    });

    function onPopupReady() {
        $elm.on('click', function (e) {
            e.preventDefault();
            videoPopup.open();
            return false;
        });
    }

});


// WEBPACK FOOTER //
// ./Sig.Web/src/controller/ctrl-popup-youtube/ctrl-popup-youtube.chunk.js